import {
  buildOperationalStepReassignmentKey,
  formatTons,
  getClientSelectionId,
} from "./resultsFleetData.js";
import {
  buildAssignmentShellViewModel,
  buildFleetSearchValue,
  getAssignmentTripCount,
} from "./resultsFleetCardShell.js";
import {
  buildTripGroups,
  normalizePendingMutationIds,
} from "./resultsFleetCardTripGroups.js";

export {
  buildFleetSearchValue,
  buildOperationalStepReassignmentKey,
  formatTons,
  getAssignmentTripCount,
  getClientSelectionId,
};

export function resolveFleetCardViewModel(props) {
  const assignment = props.assignment && typeof props.assignment === "object" ? props.assignment : {};
  const assignmentId = props.assignmentId || assignment?.truck_id || "";
  const canManageDispatcherFreeze = typeof props?.interactions?.onFreezeDelivery === "function"
    || typeof props?.interactions?.onUnfreezeDelivery === "function";
  const operationalStepRecords = Array.isArray(props.operationalSteps) ? props.operationalSteps : [];
  const pendingDeliveryIds = normalizePendingMutationIds(props.pendingDeliveryMutationIds);
  const pendingLoadingIds = normalizePendingMutationIds(props.pendingLoadingMutationIds);
  const selectedClientId = typeof props.selectedClientId === "string" ? props.selectedClientId : "";
  const selectedTripId = typeof props.selectedTripId === "string" ? props.selectedTripId : "";
  const transientActivatedStepKeys = normalizePendingMutationIds(props.transientActivatedStepKeys);
  const openOperationalReassignmentKey = typeof props.openOperationalReassignmentKey === "string"
    ? props.openOperationalReassignmentKey
    : "";
  const distanceSummary = props.distanceSummary || assignment?.total_estimated_distance_label || "Distance estimée indisponible";

  return {
    assignment,
    assignmentId,
    distanceSummary,
    fleetSearchValue: buildFleetSearchValue(assignment),
    isIdle: getAssignmentTripCount(assignment) === 0,
    isOpen: typeof props.isOpen === "boolean" ? props.isOpen : true,
    isSelectedAssignment: Boolean(props.isSelectedAssignment),
    selectedTripId,
    shell: buildAssignmentShellViewModel({
      assignment,
      assignmentId,
      distanceSummary,
    }),
    tripGroups: buildTripGroups({
      assignment,
      assignmentId,
      canManageDispatcherFreeze,
      fallbackDistanceSummary: distanceSummary,
      openOperationalReassignmentKey,
      operationalStepRecords,
      pendingDeliveryIds,
      pendingLoadingIds,
      selectedClientId,
      selectedTripId,
      transientActivatedStepKeys,
    }),
  };
}
